import { createSelector } from 'reselect'
import sortBy from 'lodash/sortBy'
import values from 'lodash/values'

export const issueDescriptionSelector = createSelector(
  state => state.issueDescriptions,
  issueDescriptions => sortBy(values(issueDescriptions) || [], 'name')
)



// WEBPACK FOOTER //
// ./src/selectors/issue-description-selectors.js